module.exports = __webpack_public_path__ + "img/hongbao.dee0bfd3.jpg";